import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

async function updateOrder(data) {
  const { deliveryCompanyName, invoiceNo, productOrderId } = data;
  const res = await http(`/admin/product-deliveries/${productOrderId}`, {
    method: "PUT",
    data: {
      deliveryCompanyName,
      invoiceNo,
    },
  });
  return res;
}

export function useUpdateOrder() {
  const queryClient = useQueryClient();

  return useMutation(updateOrder, {
    onSuccess: async (res) => {
      if (res?.status === 201 || res?.status === 200) {
        await queryClient.invalidateQueries(["product-order-parents"]);
      }
    },
  });
}
